<template src="./index.html"></template>
<script>
export default {
	props: {
		showTasks: {
			type: Boolean,
			default: false
		},
		//弹框内输入框参数
		addlist: {
			type: Object,
			default: {
				id:'',
				value: '',
				input: '',
				select: ''
			}
		}, //下拉数据
		options: { type: Object, default: [] }
	},
	data() {
		return {};
	},
	methods: {
		//弹框清空事件
		empty() {
			Object.keys(this.addlist).forEach(key => {
				this.addlist[key] = '';
			});
		},
		//下拉事件
		onSelect(e) {
			console.log(e);
			this.options.forEach(v => {
				if (e == v.name) {
					this.addlist.value = v.description;
				}
			});
		},
		//保存事件 0保存并启动 1保存 2返回
		showAddTasks(e) {
			if (e == 0) {
				this.$emit('showAddTasks',0, this.addlist);
			} else if (e == 1) {
				this.$emit('showAddTasks',1, this.addlist);
			} else {
				this.$emit('showAddTasks',2 );
			}
		},
		//关闭事件
		showTasksClose(e) {
			this.$emit('showTasksClose', e);
		}
	}
};
</script>

<style scoped>
@import url('./index.less');
</style>
